import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { actions as userActions } from '@/reducers/user';
const Login = () => {
  const dispatch = useDispatch();
  const params = '';
  // const params = common.getUrlParams();
  const { cbUrl, external } = params;

  const [callbackUrl, setCallbackUrl] = useState(cbUrl ? decodeURIComponent(cbUrl) : '');
  const [externalLink, setExternalLink] = useState(!!external);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const onChangeUser = (e) => {
    setUsername(e.target.value);
  };

  const onChangePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      userActions.upgradeUser({
        username,
        password,
        callbackUrl,
        externalLink,
      })
    );
  };

  useEffect(() => {
  }, []);

  return (
    <>
      <form className="formLogin" onSubmit={handleSubmit}>
        <input onChange={onChangeUser} value={username} type="text" name="usuario" id="text" placeholder={'usuario'} />
        <br /><br /><input onChange={onChangePassword} value={password} type="password" name="contraseña" id="password" placeholder={'password'} />
        <br /><br /><button id="login-upgrade" theme="Green" type="Solid"  >Login</button>
      </form>
    </>
  );
};
export default Login;
